import React from 'react';
import { BookOpenIcon, AppleIcon, StethoscopeIcon } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: BookOpenIcon,
    title: 'Beca Semilla',
    description: 'Educación para padres, recursos, talleres y programas de formación para fortalecer el conocimiento familiar',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400'
  }, {
    icon: AppleIcon,
    title: 'Beca Crecer',
    description: 'Acceso a consultas con especialistas, evaluaciones, estudios complementarios y segundas opiniones',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=400'
  }, {
    icon: StethoscopeIcon,
    title: 'Alianzas Estratégicas',
    description: 'Trabajo conjunto con médicos, terapeutas y organizaciones para ampliar el acceso a servicios de calidad',
    image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-180" data-mp="36bnle8nymgu4">
      <div className="max-w-6xl mx-auto" data-id="element-181" data-mp="3b9fdp3sio4yu">
        <h2 className="text-3xl sm:text-4xl font-bold text-dark text-center mb-12" data-id="element-182" data-mp="3bai83lp1spji">
          Nuestra Solución
        </h2>
        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-183" data-mp="3fdesnhy5evq3">
          {features.map((feature, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" data-id="element-184" data-mp="3k80uatefh9wz" data-mpi={index}>
              <img src={feature.image} alt={feature.title} className="w-full h-[200px] object-cover" data-id="element-185" data-mp="3u6glewdggj6h" />
              <div className="p-8" data-id="element-186" data-mp="6u79dtr8r912">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-6" data-id="element-187" data-mp="6xbklb34j518">
                  <feature.icon className="w-8 h-8 text-primary" data-id="element-188" data-mp="gtofudebhqy3" />
                </div>
                <h3 className="text-xl font-bold text-dark mb-3" data-id="element-189" data-mp="grbvjtl374hv">
                  {feature.title}
                </h3>
                <p className="text-gray-600" data-id="element-190" data-mp="27xzww9hfswc6">{feature.description}</p>
              </div>
            </div>)}
        </div>
        <div className="text-center" data-id="element-191" data-mp="2mnebbvzve3yf">
          <p className="text-2xl font-bold text-dark max-w-3xl mx-auto" data-id="element-192" data-mp="2mofn62opmuh7">
            Becas, alianzas y apoyo financiero para que ninguna familia quede
            sola.
          </p>
        </div>
      </div>
    </section>;
}